import * as React from 'react';
import { FC, useState, Fragment } from 'react';
import {
    List, Datagrid,
    TextField, EditButton,
    useNotify, useDelete,
    ListProps, Button as RAButton,
    useRecordContext,
    ReferenceField
} from 'react-admin';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import useAuthorize from '../hooks/useAuthorize';
import { UserRole } from '../types/types';

interface IDirectorySubcategory {
    id: number;
    category_id: number;
    subcategory_name: string;
    subcategory_description?: string;
}

const DeleteWithConfirmButton: FC = () => {
    const record = useRecordContext<IDirectorySubcategory>();
    const [deleteOne, { isLoading }] = useDelete();
    const [open, setOpen] = useState(false);
    const notify = useNotify();

    const handleDelete = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const confirmDelete = async () => {
        await deleteOne('directorysubcategories', { id: record.id });
        notify('resources.directorysubcategories.notification.deleted', {
            type: 'info',
            messageArgs: { smart_count: 1, name: 'Directory Subcategory' }
        });
        setOpen(false);
    };

    return (
        <Fragment>
            <RAButton
                label="Delete"
                onClick={handleDelete}
                startIcon={<DeleteIcon />}
                disabled={isLoading}
            />
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this directory subcategory?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={confirmDelete} color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
};

export const DirectorySubcategoryList: FC<ListProps> = (props) => {
    useAuthorize([UserRole.Admin]);
    return (
        <List {...props}>
            <Datagrid>
                <ReferenceField source="category_id" reference="directorycategories" label="Category">
                    <TextField source="category_name" />
                </ReferenceField>
                <TextField source="subcategory_name" label="Subcategory Name" />
                <TextField source="subcategory_description" label="Description" />
                <EditButton />
                <DeleteWithConfirmButton />
            </Datagrid>
        </List>
    );
};


